import React from 'react';
import cn from 'classnames';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';
import { TypographyTextColorVariant } from 'apps/sigma2-ui/src/components/ui/Typography';
import { TypographyVariant } from 'apps/sigma2-ui/src/components/ui/Typography';
import { TranslatedContent } from 'libs/end-to-end/src/translation-content';

export const PageHeaderStatusPill: React.FC<{
  translatedContent: TranslatedContent;
  className?: string;
  dotClassName?: string;
  textColorVariant?: TypographyTextColorVariant;
  variant?: TypographyVariant;
}> = ({
  translatedContent,
  className,
  dotClassName,
  textColorVariant = 'green-600',
  variant = 'small-label-bold',
}) => {
  return (
    <Spacing
      direction="horizontal"
      size="sm"
      className={cn('items-center rounded py-1 px-2', className)}
    >
      <div className={cn('rounded-full w-2 h-2 bg-green-500', dotClassName)} />
      <S2Typography
        translatedContent={translatedContent}
        variant={variant}
        textColorVariant={textColorVariant}
      />
    </Spacing>
  );
};
